import { IdName } from "./id-name";

export class Integrations {
    id: number;
    companyId: number;
    key: string;
    value: string;
    sourceType: IdName;

}
